import React from 'react';
import DynaModal from "../../Modal/DynaModal";
import _axios from "../../../httpService";
import {toast} from "react-toastify";

const ModalDeleteRowTable = ({onClose, setSelectedRow, tableConfig, selectedRow}) => {

  const removeDocumentRequest = async (row) => {
    const CODE_SAN = row.getData()["CODE_SAN"]
    if (!CODE_SAN) {
      alert("کد سند در جدول موجود نیست!")
    }
    try {
      const result = await _axios.delete(`${localStorage.getItem("apiUrl")}/accountingDocument/?documentCode=${CODE_SAN}&request=deleteDocument`)
      if (result.data.status) {
        row.delete();
        setSelectedRow();
        debugger
        toast.success(result.data.message)
        onClose()
      } else {
        toast.success(result.data.message)
      }
    } catch (err) {
      console.log(err)
    }
  }

  function removeRow(row) {

    if (tableConfig.type === 'document') {
      removeDocumentRequest(row)
    } else {
      _axios.delete(`${localStorage.getItem("apiUrl")}/frm_submit/?pkValue=` +
        row.getData()["primaryKey"]
        + "&entityName=" + tableConfig.entityName)
        .then((response) => {

          if (response.data.status) {
            row.delete();
            setSelectedRow();
            toast.success(response.data.message)
            onClose()
          } else {
            toast.error(response.data.message)
          }
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

  const icon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    version="1.1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 64 64"
    >
      <circle
        cx="32"
        cy="32"
        r="32"
        fill="#EE4E4E"
        className="color334a5c svgShape"
      ></circle>
      <path
        fill="#fff"
        d="M51.48 46.23H12.52c-.55 0-1.06-.3-1.33-.78-.27-.48-.26-1.07.03-1.54L30.7 12.36c.28-.45.77-.72 1.29-.72.53 0 1.02.27 1.29.72l19.48 31.55c.29.47.3 1.06.03 1.54-.25.48-.76.78-1.31.78zm-36.23-3.05h33.5L32 16.06 15.25 43.18z"
        className="colorfff svgShape"
      ></path>
      <path
        fill="#fff"
        d="M32 35.11c-.84 0-1.52-.68-1.52-1.52V22.97a1.52 1.52 0 113.04 0v10.62c0 .84-.68 1.52-1.52 1.52zm2 3.52c0 1.09-.89 1.98-1.99 1.98s-2-.89-2-1.98c0-1.09.9-1.98 2-1.98 1.09.01 1.99.9 1.99 1.98z"
        className="colorfff svgShape"
      ></path>
    </svg>
  </svg>
  return (
    <DynaModal onClose={onClose} className={'small-modal-ravan-hessab size-modal-delete-tafzil'}>

      <div className="header-modal">
        <p>{tableConfig.title}</p>

        <div onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
              fill="white"/>
            <path
              d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
              fill="white"/>
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
              fill="white"/>
          </svg>
        </div>
      </div>

      <div className="content-modal">

        <div className="box-delete">
          {icon}
          <p>از حذف مطمئن هستید</p>
        </div>

      </div>

      <div className="button-modal">
        <button onClick={onClose} className="cancel-modal">انصراف</button>
        <button className="accept-modal" onClick={() => removeRow(selectedRow)}>ثبت</button>
      </div>

    </DynaModal>
  );
};

export default ModalDeleteRowTable;